module.exports = __webpack_public_path__ + "static/img/bcg.db923178.jpg";